import AiCostLimitUsersLoader from '@UI/Pages/Administration/Shared/AiCostLimitUsersLoader';
import LevelLimits from '@UI/Pages/Administration/AiCostLimits/Sections/LevelLimits';
import type * as React from 'react';

type Props = {
	readonly accountId: number;
};

/** The user level: loads the account's users first, since their names are not in the limits. */
const UserLimits: React.FC<Props> = ({ accountId }) => {
	return (
		<AiCostLimitUsersLoader accountId={accountId}>
			{(users) => (
				<LevelLimits
					level="user"
					title="Utilisateurs"
					emptyText="Aucun plafond par utilisateur."
					addLabel="Ajouter un plafond"
					users={users}
				/>
			)}
		</AiCostLimitUsersLoader>
	);
};

export default UserLimits;
